import template from './profileTab.html';
import controller from './profileTab.controller';

let component = {
    template,
    controller
};

export default component;
